var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_529",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 28,
    height: 28
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_529)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.66667 21C4.33611 21 4.05903 20.8882 3.83542 20.6646C3.61181 20.441 3.5 20.1639 3.5 19.8333C3.5 19.5028 3.61181 19.2257 3.83542 19.0021C4.05903 18.7785 4.33611 18.6667 4.66667 18.6667H23.3333C23.6639 18.6667 23.941 18.7785 24.1646 19.0021C24.3882 19.2257 24.5 19.5028 24.5 19.8333C24.5 20.1639 24.3882 20.441 24.1646 20.6646C23.941 20.8882 23.6639 21 23.3333 21H4.66667ZM4.66667 15.1667C4.33611 15.1667 4.05903 15.0549 3.83542 14.8312C3.61181 14.6076 3.5 14.3306 3.5 14C3.5 13.6694 3.61181 13.3924 3.83542 13.1687C4.05903 12.9451 4.33611 12.8333 4.66667 12.8333H23.3333C23.6639 12.8333 23.941 12.9451 24.1646 13.1687C24.3882 13.3924 24.5 13.6694 24.5 14C24.5 14.3306 24.3882 14.6076 24.1646 14.8312C23.941 15.0549 23.6639 15.1667 23.3333 15.1667H4.66667ZM4.66667 9.33333C4.33611 9.33333 4.05903 9.22153 3.83542 8.99792C3.61181 8.77431 3.5 8.49722 3.5 8.16667C3.5 7.83611 3.61181 7.55903 3.83542 7.33542C4.05903 7.11181 4.33611 7 4.66667 7H23.3333C23.6639 7 23.941 7.11181 24.1646 7.33542C24.3882 7.55903 24.5 7.83611 24.5 8.16667C24.5 8.49722 24.3882 8.77431 24.1646 8.99792C23.941 9.22153 23.6639 9.33333 23.3333 9.33333H4.66667Z",
    fill: "#1C1B1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.746b1af07753e57391be185c44bcda0b.svg";
export { ForwardRef as ReactComponent };